import { displayLatLonInCompassFormat } from '@deckee/utilities';
import React from 'react';
import { bowser } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Fuel dock',
  synonyms: 'gas petrol',
  group: 'standardMarker',
  typeUrl: 'fuel-dock',
  icon: {
    baseShape: bowser,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'fuelDockMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Fuel dock',
      itemTitleFunction: (item) => (item && item.title) || 'Fuel dock',
    },
    creationOptions: {
      menuText: 'Fuel dock',
      newTitle: 'Fuel dock location',
      titlePlaceholder: 'Name of fuel location',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a place where you can get fuel for your boat.
          Include information such as types of fuel, payment methods and access
          to the dock or station.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [
        { label: 'Diesel', isActive: false },
        { label: 'Unleaded', isActive: false },
        { label: 'Shops nearby', isActive: false },
        { label: 'Wash down', isActive: false },
        { label: 'Self service', isActive: false },
        { label: 'Full service', isActive: false },
        { label: 'Over priced', isActive: false },
        { label: 'Difficult access', isActive: false },
        { label: 'Membership required', isActive: false },
      ],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Fuel dock location',
    description: displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
